import { useEffect, useState } from 'react';
import ExternalLinks, {
  AccountMenu,
  HeaderToolbarButton,
  NotificationDialog,
  SkipButton,
} from './headerComponents/header-steps';
import RegionNavLink from './region-navlink';
import { useUserProfile } from '../../../../providers/user-provider';
import { DataAnalyticsLocations, DataAnalyticsTypes } from '../../../basic/analytics';
import { getRegionFromUri } from '../../../../utils/regionUtils';
import { INotificationErrMsg } from '../IHeader';
import { getSession } from '../../../../utils/sessionStorageUtils';

interface IHeaderToolbarProps {
  navToolbarMap: any;
  regionMessages: any;
  notificationErrorMsg: INotificationErrMsg[];
}
enum COMPONENTTYPE {
  BUTTON = 'BUTTON',
  EXTERNALLINK = 'EXTERNALLINK',
  DIALOG = 'DIALOG',
  REGION = 'REGION',
  NEWMENU = 'NEWMENU',
  SKIPBUTTON = 'SKIPBUTTON',
}
export enum NavToolbarIcons {
  ShowAfterLogin = 'showafterlogin',
  Authenticated = 'authenticated',
  Cart = 'cart',
  Logout = 'Logout',
  Notification = 'Notifications',
  None = 'None',
}

const HeaderToolbar = ({
  navToolbarMap,
  regionMessages,
  notificationErrorMsg,
}: IHeaderToolbarProps) => {
  const { userProfile } = useUserProfile();
  const url = new URL(window.location.href);
  const [relativePath, setRelativePath] = useState<string>();
  const region = getRegionFromUri();
  const isLoggedIn = getSession('isLoggedIn');
  const { loginError } = useUserProfile();
  // Show the logged-in header when profile data exists or the session indicates a logged-in user
  // outside the login route and there is no login error.
  const showLoggedInHeaderView =
    userProfile ??
    (!loginError &&
      isLoggedIn &&
      isLoggedIn === 'true' &&
      location.pathname.split('/')[2] !== 'login');

  useEffect(() => {
    setRelativePath(url.pathname);
  }, [url]);

  const getClickKeys = (key: any) => {
    let keys = '';
    if (relativePath) {
      const relativeList = relativePath.split('/');
      relativeList?.map((item: any) => {
        if (item && region !== item) keys += item + '_';
      });
      keys = keys + key;
    }
    return keys;
  };

  const determineType = (key: string) => {
    if (key === 'kporg_link') return COMPONENTTYPE.EXTERNALLINK;
    if (key === 'notifications') return COMPONENTTYPE.DIALOG;
    if (key === 'cart') return COMPONENTTYPE.BUTTON;
    if (key === 'region_pickers') return COMPONENTTYPE.REGION;
    if (key === 'site_navigation_new_menu') return COMPONENTTYPE.NEWMENU;
    if (key === 'skip_to_main_content') return COMPONENTTYPE.SKIPBUTTON;
    return null;
  };

  const renderComponent = (type: COMPONENTTYPE, item: any, key: any) => {
    const keys = getClickKeys(key);

    switch (type) {
      case COMPONENTTYPE.EXTERNALLINK:
        return (
          <ExternalLinks
            href={item?.path}
            label={item?.label}
            divider={true}
            type={DataAnalyticsTypes.Link}
            click={keys}
            locations={[DataAnalyticsLocations.Header]}
          />
        );
      case COMPONENTTYPE.DIALOG:
        return (showLoggedInHeaderView) &&
          item?.displayrule === NavToolbarIcons.ShowAfterLogin ? (
          <NotificationDialog
            data={item}
            divider={true}
            notificationErrorMsg={notificationErrorMsg}
          />
        ) : (
          <></>
        );
      case COMPONENTTYPE.REGION:
        return <RegionNavLink regionMessages={regionMessages} />;
      case COMPONENTTYPE.BUTTON:
        return (showLoggedInHeaderView) &&
          item?.displayrule === NavToolbarIcons.ShowAfterLogin ? (
          <HeaderToolbarButton
            data={item}
            type={DataAnalyticsTypes.Button}
            click={keys}
            locations={[DataAnalyticsLocations.Header]}
          />
        ) : (
          <></>
        );
      case COMPONENTTYPE.NEWMENU:
        return showLoggedInHeaderView ? <AccountMenu menuMap={item} /> : <></>;
      case COMPONENTTYPE.SKIPBUTTON:
        return <SkipButton name={item?.label} />;
      default:
        return <></>;
    }
  };
  
  if (!navToolbarMap || !navToolbarMap?.topToolbar) return null;
  const { topToolbar } = navToolbarMap;

  return (
    <div className="grid grid-cols-4 gap-4">
      <div data-testid="header-toolbar" className="col-span-4 flex justify-end items-center">
        {Object.keys(topToolbar)?.map((key: any, index: number) => {
          const toolBarItem = topToolbar[key];
          const type = determineType(key);
          return <div key={index}>{type && renderComponent(type, toolBarItem, key)}</div>;
        })}
      </div>
    </div>
  );
};
export default HeaderToolbar;
